<template>
  <el-dialog title="Thêm vận đơn vào đối soát" :visible.sync="dialog">
    <el-form label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmit">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="Chọn file đối soát" class="is-required">
            <input type="file" id="fileInput" ref="fileInput" name="file" @change="loadExcel" />
          </el-form-item>
        </el-col>
        <el-col v-if="fileColumnField.length > 1">
          <el-divider></el-divider>
        </el-col>
        <el-col :span="24" v-if="fileColumnField.length > 1">
          <h3>Chọn các cột dữ liệu tương ứng</h3>
          <table cellspacing="0" cellpadding="5" border="0" style="width: 100%">
            <thead>
              <tr>
                <td><strong>Dữ liệu đầu vào</strong></td>
                <td><strong>Cột tương ứng</strong></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Đơn vị vận chuyển</td>
                <td>
                  <el-select v-model="carrier" filterable clearable placeholder="Chọn cột tương ứng">
                    <el-option v-for="carrier in carriers" :key="carrier.id" :label="carrier.name" :value="carrier.id">
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-for="(field, index) in filteredFileColumnField" :key="'row-' + index">
                <td>{{ field.text }}</td>
                <td>
                  <el-select v-model="filteredFileColumnField[index].file" placeholder="Chọn cột tương ứng">
                    <el-option v-for="item in fileColumnField" :key="item.value" :label="item.text" :value="item.value">
                    </el-option>
                  </el-select>
                </td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">Hủy bỏ</el-button>
      <el-button type="primary" :loading="submitting" @click="validateBeforeSubmit"
        :disabled="dataExcelJson.length === 0">Tải lên</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import XLSX from 'xlsx'
import { head, chunk, forEach, cloneDeep } from 'lodash'
import { updateCrossCheck, updateCrossCheckFee, updateCrossCheckFee1 } from 'src/api/compares'
import { CROSS_CHECK_TYPE } from "src/constants";
const fileColumnField = [{
  value: 'none',
  text: 'Không chọn'
}]
export default {
  name: 'DialogAddShipmentToCompare',
  data() {
    return {
      dialog: false,
      file: {},
      fileColumnField: cloneDeep(fileColumnField),
      systemColumnField: [
        { text: 'Mã HVC/Goship', system: 'ma_don', file: '', maps: ['ma_hvc', 'ma_don_hang', 'ma_e1'] },
        { text: 'Cân nặng', system: 'can_nang', file: '', maps: ['can_nang', 'khoi_luong', 'can', 'can_tp', 'tp'] },
        { text: 'Tiền COD', system: 'cod', file: '', maps: ['cod', 'tien_thu_ho', 'tien_cod', 'cod_thanh_toan', 'thu_ho', 'cuoc_cod'] },
        { text: 'Phí vận chuyển', system: 'phi', file: '', maps: ['phi', 'phi_giao_hang', 'tong_phi_dich_vu', 'cuoc_chinh'] }
      ],
      formatCorrect: false,
      submitting: false,
      dataExcelJson: [],
      carrier: ''
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    },
  },

  computed: {
    ...mapGetters('carrier', ['carriers']),
    filteredFileColumnField() {
      return this.type === CROSS_CHECK_TYPE.COD
        ? this.systemColumnField
        : this.systemColumnField.filter(item => item.system !== 'can_nang' && item.system !== 'cod');
    }
  },

  methods: {
    ...mapActions('carrier', ['getAllCarriers']),
    checkFileFormat(fileName) {
      let exten = fileName.substring(fileName.length - 3, fileName.length)
      if (exten === 'csv' || exten === 'xls' || exten === 'lsx') {
        return true
      } else {
        return false
      }
    },
    loadExcel(e) {
      this.toggleLoadding(true)
      let fileUpload = e.target.files[0]
      if (fileUpload && this.checkFileFormat(fileUpload.name)) {
        this.formatCorrect = true
        this.file = fileUpload
        let reader = new FileReader(fileUpload)
        reader.onload = (e) => {
          let binary = ''
          let bytes = new Uint8Array(e.target.result)
          let length = bytes.byteLength
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          let wb = XLSX.read(binary, { type: 'binary' })
          let ws = wb.Sheets[wb.SheetNames[0]]

          this.fileColumnField = cloneDeep(fileColumnField)
          if (!ws || !ws['!ref']) return
          let ref = XLSX.utils.decode_range(ws['!ref'])
          for (let C = ref.s.c; C <= ref.e.c; ++C) {
            let cell = ws[XLSX.utils.encode_cell({ r: ref.s.r, c: C })]
            if (cell && cell.t === 's') {
              if (cell.v) {
                let originCell = cell.v
                cell.v = cell.v.trim()
                  .replace(/\s/g, '_')
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
                this.fileColumnField.push({
                  value: cell.v,
                  text: originCell.trim()
                })
              }
              if (cell.w) {
                cell.w = cell.w.trim()
                  .replace(/\s/g, '_')
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
              }
            }
          }

          this.dataExcelJson = XLSX.utils.sheet_to_json(ws, { defval: '' })

          if (this.dataExcelJson.length) {
            this.dataExcelJson = this.dataExcelJson.map(row => {
              const processedRow = {}
              for (const [key, value] of Object.entries(row)) {
                processedRow[key] = typeof value === 'number' && Math.abs(value - Math.round(value)) < 1e-8 ? Math.round(value) : value
              }
              return processedRow
            })

            this.filteredFileColumnField.map(obj => {
              forEach(this.fileColumnField, item => {
                let index = obj.maps.indexOf(item.value)
                if (index > -1) {
                  obj.file = item.value
                  return false
                }
              })

              return obj
            })
          }
          this.toggleLoadding(false)
        }
        reader.readAsArrayBuffer(fileUpload)
      } else {
        this.formatCorrect = false
        this.toggleLoadding(false)
      }
    },
    getFormData() {
      let mapper = {}
      this.filteredFileColumnField.forEach(obj => {
        mapper[obj.system] = obj.file
      })
      if ('ma_don' in mapper) {
        this.dataExcelJson.map((item) => {
          item[mapper['ma_don']] = item[mapper['ma_don']].replace(/^'/, '') + ''
        })
      }
      return {
        data: this.dataExcelJson,
        mapper: mapper
      }
    },
    async validateBeforeSubmit() {
      this.submitting = true
      let formData = this.getFormData()
      let dataChunk = chunk(formData.data, 500)
      let requests = []
      forEach(dataChunk, (data) => {
        switch(this.type) {
          case CROSS_CHECK_TYPE.COD:
            requests.push(() => updateCrossCheck(this.$route.params.id, {
              carrier: this.carrier,
              data: data,
              mapper: formData.mapper
            }))
            break
          case CROSS_CHECK_TYPE.FEE:
            requests.push(() => updateCrossCheckFee(this.$route.params.id, {
              carrier: this.carrier,
              data: data,
              mapper: formData.mapper
            }))
            break
          case CROSS_CHECK_TYPE.FEE1:
            requests.push(() => updateCrossCheckFee1(this.$route.params.id, {
              carrier: this.carrier,
              data: data,
              mapper: formData.mapper
            }))
            break

        }
      })

      // let dataRequest = chunk(requests, 5)
      let responses = []
      let count = 0; // Số lượng request đang chạy đồng thời
      const maxConcurrent = 5; // Số lượng request tối đa chạy đồng thời

      // Chạy 5 request xong 1 cái thì sẽ thêm 1 cái mới
      try {
        while (true) {
          // Nếu không còn request nào và không còn request đang chạy, thoát khỏi vòng lặp
          if (requests.length === 0 && count === 0) {
            break;
          }

          // Nếu số lượng request đang chạy nhỏ hơn giới hạn, thêm request mới
          if (count < maxConcurrent && requests.length > 0) {
            const request = requests.shift(); // Lấy request đầu tiên từ hàng đợi
            count++; // Tăng số lượng request đang chạy

            // Thực hiện request
            request()
              .then((response) => {
                  responses.push(response); // Lưu kết quả
              })
              .catch((error) => {
                console.error("Lỗi khi thực hiện request:", error);
              })
              .finally(() => {
                count--; // Giảm số lượng request đang chạy khi hoàn thành
              });
          }

          // Chờ một khoảng thời gian ngắn trước khi kiểm tra lại
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        // Kiểm tra kết quả đầu tiên
        if (responses.length > 0) {
        const firstResponse = responses[0];
          switch (firstResponse.code) {
            case 200:
              this.resetData()
              formData = null
              this.$emit("success");
              this.dialog = false;
              this.$message({
                type: "success",
                message: "Upload bảng kê thành công! Quá trình hoàn tất sẽ được thông báo trên Telegram.",
              });
              break;
            case 422:
              let er = firstResponse.data;
              let message = head(er);
              this.$store.dispatch("showNotify", {
                title: "Vui lòng kiểm tra thông tin cần nhập",
                body: message,
                type: "warning",
              });
              break;
            default:
              this.$message({
                type: "error",
                message: "Thêm đối soát thất bại, vui lòng kiểm tra lại thông tin.",
              });
          }
        }
      } catch (error) {
        this.$message({
          type: "error",
          message: "Đã xảy ra lỗi trong quá trình xử lý.",
        });
      } finally {
        this.submitting = false;
      }

      // Chạy 5 request 1 lần
      // try {
      //   for (const group of dataRequest) {
      //     responses = await Promise.all(group.map(fn => fn()))
      //     responses.push(...responses)
      //   }
      //   // Kiểm tra kết quả của từng nhóm
      //   const response = responses[0]

      //   switch (response.code) {
      //     case 200:
      //       this.resetFileInput()
      //       this.fileColumnField = cloneDeep(fileColumnField)
      //       this.$emit('success')
      //       this.dialog = false
      //       this.$message({
      //         type: 'success',
      //         message: 'Upload bảng kê thành công! Quá trình hoàn tất sẽ được thông báo trên Telegram.'
      //       })
      //       break
      //     case 422:
      //       let er = response.data
      //       let message = head(er)
      //       this.$store.dispatch('showNotify', {
      //         title: 'Vui lòng kiểm tra thông tin cần nhập',
      //         body: message,
      //         type: 'warning'
      //       })
      //       break
      //     default:
      //       this.$message({
      //         type: 'error',
      //         message: 'Thêm đối soát thất bại, vui lòng kiểm tra lại thông tin.'
      //       })
      //   }
      // } catch (error) {
      //   console.error("Đã xảy ra lỗi:", error);
      //   this.$message({
      //     type: "error",
      //     message: "Đã xảy ra lỗi trong quá trình xử lý.",
      //   });
      // } finally {
      //   this.submitting = false;
      // }
    },
    resetData() {
      this.resetFileInput()
      this.dataExcelJson = []
      this.fileColumnField = cloneDeep(fileColumnField)
      this.file = {}
      this.carrier = ''
      this.formatCorrect = false
    },
    async retryRequest(request, maxRetries = 3) {
      let retries = 0;
      while (retries < maxRetries) {
        try {
          const response = await request();
          if (response.code === 200) {
            return response; // Thành công, trả về kết quả
          }
        } catch (error) {
          console.error(`Lỗi khi thực hiện request (lần thử ${retries + 1}):`, error);
        }
        retries++;
      }
      throw new Error(`Request thất bại sau ${maxRetries} lần thử.`);
    },
    resetFileInput() {
      const input = this.$refs.fileInput
      input.value = null
    }
  },

  mounted() {
    this.dialog = this.value
    this.getAllCarriers()
  },

  watch: {
    value: function (value) {
      this.dialog = value
    },
    dialog: function () {
      this.$emit('input', this.dialog)
    }
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// DialogAddShipmentToCompare.vue?5b347dbc